import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { RoutePath, ApiFailedReason } from '@quizzach/interfaces';
import { BtnTeal, CartPage, CtHead } from '@quizzach/styles';
import { AlertMessage, Navigation } from '@quizzach/components';

export const CartNotAuthenticated = () => {
	const { t } = useTranslation();

	return (
		<CartPage>
			<Navigation />
			<CtHead>
				<div>
					<h1>
						<span className='row'>
							<span>{t('common.checkout.title')}</span>
						</span>
					</h1>
				</div>
			</CtHead>
			<div style={{ padding: '0 var(--pad) 130px' }}>
				<p
					style={{
						color: 'var(--brown)',
						fontSize: '17.5px',
						maxWidth: '560px',
					}}
				>
					{t('cart.notAuthenticated.message')}
				</p>
				<BtnTeal
					$small
					as={Link}
					to={RoutePath.Login}
					style={{ marginTop: '20px' }}
				>
					{t('cart.notAuthenticated.loginButton')}
				</BtnTeal>
			</div>
		</CartPage>
	);
};

export const CartError = () => (
	<CartPage>
		<Navigation />
		<div style={{ padding: '150px var(--pad) 130px' }}>
			<AlertMessage code={ApiFailedReason.addToCart} type='error' />
		</div>
	</CartPage>
);

export const CartEmpty = () => {
	const { t } = useTranslation();

	return (
		<CartPage>
			<Navigation />
			<CtHead>
				<div>
					<h1>
						<span className='row'>
							<span>{t('cart.empty.title')}</span>
						</span>
					</h1>
				</div>
			</CtHead>
			<div style={{ padding: '0 var(--pad) 130px' }}>
				<p
					style={{
						color: 'var(--brown)',
						fontSize: '17.5px',
						maxWidth: '560px',
					}}
				>
					{t('cart.empty.description')}
				</p>
			</div>
		</CartPage>
	);
};
